import {
  Component,
  ElementRef,
  AfterViewInit,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { filter } from 'rxjs/operators';
import { MarketplaceProfileComponent } from 'src/app/customers/layout/component-layout/marketplace-profile/marketplace-profile.component';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { MemberNotificationService } from 'src/app/shareModule/services/member-notification.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { SignInComponent } from '../component-layout/sign-in/sign-in.component';
import { ShepherdService } from 'angular-shepherd';
import {
  getStepsAddProduct,
  stepsVerifyEmail,
  stepsSuggestionProduct,
  stepsProfile,
  stepsFavoritesProduct,
  stepsCreateNews,
  defaultStepOptions,
} from './data-shepherd';
import { CommunityProduct } from 'src/app/shareModule/models/community-product.model';
import { Store } from '@ngrx/store';
import { loadAllCommunityProducts } from 'src/app/shareModule/states/community-product';
import { Subject, Subscription, timer } from 'rxjs';
import { ChatbotService } from '../../../shareModule/component/chat/chatbot/chatbot.service';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { loadUser } from 'src/app/shareModule/states/user-details';
import { AppState } from 'src/app/shareModule/states/app.state';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { SeoService } from 'src/app/shareModule/services/seo.service';
import { environment } from 'src/environments/environment';
import { SideLeftMenuComponent } from '../component-layout/side-left-menu/side-left-menu.component';

@Component({
  selector: 'app-customers-layout',
  templateUrl: './customers-layout.component.html',
  styleUrls: ['./customers-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomersLayoutComponent
  implements OnInit, AfterViewInit, OnDestroy {
  private destroy$ = new Subject<void>();
  @ViewChild('SignIn', { static: false }) signIn: SignInComponent;
  @ViewChild('MarketplaceProfile')
  marketplaceProfileSection: MarketplaceProfileComponent;

  @ViewChild('menuOptions', { static: false }) menuOptions: any;

  public navbarVisible: boolean = true;
  public navbarScroll: boolean = true;
  public mobilePopUpTimer = null;
  public isUserLogin: any = 0;
  public currentMenu: any = '';
  public mobileAds = [];

  ///////////////////
  public messageAtTop = '';
  private fetchMessageAtTop() {
    this.auth.getSiteInfo('MESSAGE_AT_TOP').subscribe({
      error: console.error,
      next: (data: any) => (this.messageAtTop = data?.data?.value),
    });
  }

  //////////////////

  private lastScrollTop = 0;
  submitted = false;

  appUserId: any = 0;
  referralCode: any;
  menuSliderLeft = false;
  sloganText: string = 'We Recommend the Good Stuff';
  isNewMessage: boolean = false;
  customerService: boolean = false;
  isReferralLink: boolean = false;
  imgUrl: string = environment.ImageUrl;
  profileAvatar: string;

  //PLEASE ACCEPT THIS CHANGE
  totalUnreadMessagesCount = 0;
  tabMenu: number = 0;
  constructor(
    public auth: AuthServiceService,
    private router: Router,
    private route: ActivatedRoute,
    private local: LocalServiceService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private memberNotificationService: MemberNotificationService,
    public sharedService: SharedService,
    public roleService: RoleService,
    private shepherdService: ShepherdService,
    private store: Store<AppState>,
    private chatbotService: ChatbotService,
    public commonService: CommonService,
    private seoService: SeoService,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    //PLEASE ACCEPT THIS CHANGE
    this.totalUnreadMessagesCount =
      chatbotService.getTotalUnreadMessagesCount();
    chatbotService.chatTotalUnreadCount$.subscribe((data) => {
      this.totalUnreadMessagesCount = data;
    });
    this.sharedService.chatNowSubject.subscribe((response: any) => {
      this.openProfilePopup(response?.menu);
    });
  }
  public get areThereNewMessages(): boolean {
    return this.totalUnreadMessagesCount > 0;
  }

  /************************ Code related to browse hover ************************************/
  public areBrowserChildrenShowing = false;
  public browseMouseIn(event){
    this.areBrowserChildrenShowing = true;
  }
  public browseMouseOut(event){
    this.areBrowserChildrenShowing = false;
  }
  public relationShips = []
  public selectedMainCategory = null;
  public selectedSubCategory = null
  private _getRelationShips(){
    this.auth.getAllMemberCategorieRelationship()
    .subscribe({
      next: data =>{
        this.relationShips = data.body;
        for(const cat of this.relationShips){
          console.log({cat})
          for(const subcat of cat.subCategory){
            this.relationShips.push(
              subcat
            )
          }
        }
        console.log('relationship', this.relationShips)
      },
      error: console.error
    })
  }
  public selectedSubCatSlug = null;
  public currentTypesList = []
  public areTypesLoading= false;
  public showTypesOf(cat){
    this.currentTypesList = []
    this.areTypesLoading = true;
    this.auth.getTypesOfCategory(cat.categorieChildId).subscribe({
      next: (data: any)=>{
        this.currentTypesList = data.data;
        if(!this.currentTypesList.length){
          this.areBrowserChildrenShowing = false;
          this.router.navigateByUrl('/category/' + cat.catSlug)
        }
        this.areTypesLoading = false;
       
        this.cdr.detectChanges()

      },
      error: err =>{
        console.error(err)
        this.areTypesLoading = false
        this.router.navigateByUrl('/category/' + cat.catSlug) //just in case
        this.areBrowserChildrenShowing = false;

      }
    })
  }
  /**************************************************************************************** */

  public openAIChat() {
    this.sharedService.triggerChatNow({
      chatingNow: 'ai',
      menu: 'chat',
      chatTitle: 'Loading...',
    });
  }
  public clickLogin() {
    this.clickButton('loginBtn');
    this.closeExplainerUntilNextProduct();
  }

  closeMenus() {
    if (this.isUserLogin && this.marketplaceProfileSection?.showProfileMenu) {
      this.marketplaceProfileSection.showProfileMenu = false;
      if (isPlatformBrowser(this.platformId)) {
        document.body.style.overflow = '';
      }
    }
    this.menuSliderLeft = false;
  }

  private getRandom(max) {
    let rnd = Math.random() * max;
    rnd = Math.floor(rnd);
    return rnd;
  }
  public editCurrentProduct() {
    this.sharedService.editProductIdSubject.next(null);
  }
  public selectedMobileAd = null;
  public giggleWiz = false;
  private adChangeTimeout = null;
  public showProductExplainer = false;
  public explainText = '';
  public isExplanationProductClaimable = false;
  public showExplainerParam2 = true;

  public closeExplainerUntilNextProduct() {
    this.showExplainerParam2 = false;
  }

  public isWizardVisisble = true;
  ////////////////////////////////////////////////////////////////
  public isReading = false;
  private nowReadingText = '';

  public pause() {
    const synth = speechSynthesis;

    if (synth.speaking && !synth.paused) {
      console.log('Pausing read');
      speechSynthesis.pause();
      this.isReading = false;
    } else {
      console.log('Cannot pause, either not speaking or already paused');
    }
  }

  public async read(text) {
    const synth = window.speechSynthesis;
    if (synth.speaking && this.nowReadingText != text) {
      await synth.cancel();
    }
    if (synth.speaking && this.nowReadingText === text) {
      await synth.resume();
    }
    this.nowReadingText = text;

    const userAgent = navigator.userAgent;
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.rate = 1;

    const voices = speechSynthesis.getVoices();

    let voice = null;
    //console.log('userAgent is', userAgent)
    if (
      userAgent.includes('Chrome') &&
      !userAgent.includes('Edg') &&
      !userAgent.includes('OPR') &&
      !userAgent.includes('Brave')
    ) {
      console.log('choosing a device on chrome or edge');
      const cand = voices.find(
        (voice) =>
          voices.find(
            (voice) =>
              voice.name.toLowerCase().includes('moira') ||
              voice.lang === 'en-SG'
          ) ||
          voice.lang == 'en-GB' ||
          voice.name.includes('Female') ||
          (voice.lang.includes('en') && voice.name.includes('Google'))
      );
      if (cand) {
        voice = cand;
      }
      //console.log('Picked voice for chrome ', voice)
    } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
      //console.log('the browser is safari')
      const cand = voices.find((voice) => voice.name.includes('Siri'));
      if (cand) {
        voice = cand;
      }
    } else {
      console.log('browser not clear');
    }
    if (voice) {
      utterance.voice = voice;
    }

    this.isReading = true;
    speechSynthesis.speak(utterance);
    utterance.onend = () => {
      this.isReading = false;
    };
  }
  ///////////////////////////////////////////////////////////////
  public get isMobile(): boolean {
    return window.innerWidth >= 767;
  }

  public get showProductExplanation(): boolean {
    if (this.sharedService.isBrowser()) {
      const url = window.location.href;
      return url.includes('?product=') || url.includes('/product/');
    }
    return false;
  }
  public glowMobileAds = true;
  timeout1: any;
  timeout2: any;
  public showMobileAd() {
    const url = window.location.href;
    const isSeeingProductDetail =
      url.includes('?product=') || url.includes('/product/');

    if (isSeeingProductDetail || this.showProductExplainer) {
      //while product is being explained not mobile ad
      return;
    }

    if (this.mobileAds.length) {
      if (this.adChangeTimeout) {
        clearTimeout(this.adChangeTimeout);
        this.adChangeTimeout = null;
      }
      if (this.selectedMobileAd) {
        this.selectedMobileAd = null;
        return;
      }
      this.selectedMobileAd =
        this.mobileAds[this.getRandom(this.mobileAds.length)];

      this.adChangeTimeout = setTimeout(() => {
        this.selectedMobileAd = null;
      }, 3000);
      this.glowMobileAds = false;
      this.local.clearTimeout(this.timeout1)
      this.timeout1 = setTimeout(() => {
        this.glowMobileAds = true;
      }, 20_000); //glow will stop for 20 sec then return(only for ads)
    } else {
      this.giggleWiz = true;
      const audio = new Audio('../../../../assets/sounds/ouch.m4a');

      audio.play().catch(console.error);

      this.local.clearTimeout(this.timeout2)
      this.timeout2 = setTimeout(() => {
        this.giggleWiz = false;
      }, 2000);
    }
  }

  // openShopPopup(tab1, tab2) {
  //   this.openProfilePopup(tab1);
  //   setTimeout(() => {
  //     this.sharedService.triggerInitMarketProfile(tab2);
  //   }, 100);
  // }

  // openProfileTabPopup(tab1, tab2) {
  //   this.openProfilePopup(tab1);
  //   setTimeout(() => {
  //     this.sharedService.triggerInitProfile(tab2);
  //   }, 100);
  // }
  public get isOnBrowser() {
    return this.sharedService.isBrowser();
  }

  private clickButton(id) {
    const button = document.getElementById(id);
    if (button) {
      button.click();
    } else {
      console.error('button not found!');
    }
  }
  public openRefer() {
    this.clickButton('refer-btn');
  }
  public openAddExperience() {
    this.clickButton('add-experience-btn');
  }

  private showAIExplanationForProductSubscritpion: Subscription | null = null;
  public isPopupOpen = false;
  timeout3: any;
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (window.location.hostname === 'sgbojio.com') {
        this.sloganText = 'Good things must be Shared';
      }
      if (window.location.hostname === 'brands4good.asia') {
        this.sloganText = 'Grow Your Business With Us';
      }
      this.fetchMessageAtTop();
      this._getRelationShips()

      const excludedRoute = [
        'www.fusionapp.store',
        'www.sgbojio.com',
        'www.brands4good.asia',
        'www.ezcart.app',
        'www.corporatepromo.sg',
        'www.combuu.com',
        'www.myvip.asia',
      ];

      if (excludedRoute.includes(window.location.hostname))
        this.seoService.updateNoIndex(true);

      this.route.queryParams.subscribe((params) => {
        const status = params['status'];

        if (status === 'complete') {
          Swal.fire('Added!', 'Card added successfully', 'success');
        } else if (status) {
          Swal.fire('Failed!', 'Operation failed', 'warning');
        }
      });

      this.checkPage();
      this.auth.getAllHomepageAds().subscribe({
        next: (data: any) => {
          this.mobileAds = data.data;
        },
        error: console.error,
      });
      //this.local.fetchUser();
      this.local.getUserDetailsObserver().subscribe((user) => {
        if (!this.sharedService.isBrowser()) {
          return;
        }
        if (user?.id) {
          //console.log(user, "USER SIDEBAR")
          this.referralCode = user.referralCode;
          this.appUserId = user.id;
          this.isUserLogin = 1;
          this.profileAvatar = this.imgUrl + user.profileCharacterImageFile;
          this.local.periodicallyCheckLoginUserData();
          this.store.dispatch(loadUser({}));
          if (user.theme) {
            this.commonService.setTheme(user.theme);
          }
        } else {
          this.isUserLogin = 0;
          this.openSignInPopupForMobile();
        }
      });

      this.showAIExplanationForProductSubscritpion =
        this.sharedService.showAIExplanationForProductSubject.subscribe(
          (productData) => {
            //console.log({productData})
            this.isPopupOpen = window.location.href.includes('?product=');
            if (productData.closeAll) {
              //this is called when viewproductdetail component is closed
              this.showExplainerParam2 = this.isMobile; //still hide on mobile
              this.showProductExplainer = false;
              this.explainText = '';
              return;
            }
            const url = window.location.href;
            this.showProductExplainer =
              url.includes('?product=') || url.includes('/product/'); //never show product explainer if not on product single page or popup is opened
            this.explainText = productData.explainText;
            this.isExplanationProductClaimable =
              productData.isExplanationProductClaimable;
          }
        );
      if (
        JSON.parse(localStorage.getItem('tutorials')) ||
        (JSON.parse(localStorage.getItem('tutorials')) === null &&
          this.sharedService.isBrowser())
      ) {
        this.sharedService.shepherd$.subscribe((res: any) => {
          if (res === 'add-product') {
            this.shepherdService.addSteps(
              getStepsAddProduct(this.auth.enableLoader)
            );
            this.shepherdService.start();
          } else if (res === 'verify-email') {
            this.router.navigateByUrl('/advanced-settings').then(() => {
              this.local.clearTimeout(this.timeout3)
              this.timeout3 = setTimeout(() => {
                this.shepherdService.addSteps(stepsVerifyEmail);
                this.shepherdService.start();
              }, 100);
            });
          } else if (res === 'new-user') {
            this.router.navigateByUrl('/me/profile').then(() => {
              this.local.clearTimeout(this.timeout3)
              this.timeout3 = setTimeout(() => {
                this.shepherdService.addSteps(stepsProfile);
                this.shepherdService.start();
              }, 100);
            });
          } else if (res === 'suggestion-product') {
            this.router.navigateByUrl('/').then(() => {
              this.local.clearTimeout(this.timeout3)
              this.timeout3 = setTimeout(() => {
                this.shepherdService.addSteps(
                  stepsSuggestionProduct(this.auth.enableLoader)
                );
                this.shepherdService.start();
              }, 3000);
            });
          } else if (res === 'favorites-product') {
            this.router.navigateByUrl('/').then(() => {
              this.local.clearTimeout(this.timeout3)
              this.timeout3 = setTimeout(() => {
                this.shepherdService.addSteps(stepsFavoritesProduct);
                this.shepherdService.start();
              }, 3000);
            });
          } else if (res === 'create-forum') {
          } else if (res === 'answer-forum') {
          } else if (res === 'create-news') {
            this.router.navigateByUrl('/news').then(() => {
              this.local.clearTimeout(this.timeout3)
              this.timeout3 = setTimeout(() => {
                this.shepherdService.addSteps(stepsCreateNews);
                this.shepherdService.start();
              }, 1000);
            });
          }
          this.shepherdService.defaultStepOptions = defaultStepOptions;
          this.shepherdService.modal = true;
          this.shepherdService.confirmCancel = false;
        });
      }

      if (this.sharedService.isBrowser()) {
        if (localStorage.getItem('selectedTheme') === 'space') {
          document.documentElement.classList.add('space');
        } else if (localStorage.getItem('selectedTheme') === 'beige') {
          document.documentElement.classList.add('beige');
        } else if (localStorage.getItem('selectedTheme') === 'winter') {
          document.documentElement.classList.add('winter');
        } else if (localStorage.getItem('selectedTheme') === 'bronze') {
          document.documentElement.classList.add('bronze');
        }
      }

      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.marketplaceProfileSection?.showProfileMenu
            ? (this.marketplaceProfileSection.showProfileMenu = false)
            : '';
          document.body.style.overflow = '';
          this.menuSliderLeft = false;
        }
      });
    }
  }

  public goToGiveAway() {
    this.router.navigate(['giveaway']);
  }

  public openSignInPopupForMobile() {
    // if (window.innerWidth < 768 && this.router.url == '/') {
    //   timer(2000).subscribe(() => {
    //     this.openSigninModal();
    //   });
    // }
  }

  private navigationSubscription: Subscription;

  ngAfterViewInit() {
    this.navigationSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (this.shepherdService.defaultStepOptions?.buttons?.length) {
          this.shepherdService?.complete(); // or use .cancel() if you prefer to cancel the tour
        }
      }
    });
    if (this.sharedService.isBrowser()) {
      this.showExplainerParam2 = this.isMobile;
    }
  }

  ngOnDestroy() {
    // Clean up the subscription when the component is destroyed
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
    this.local.clearTimeout(this.timeout1)
    this.local.clearTimeout(this.timeout2)
    this.local.clearTimeout(this.timeout3)
    this.showAIExplanationForProductSubscritpion?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  @ViewChild('sideLeftMenu', { static: false })
  sideLeftMenu: SideLeftMenuComponent;

  @HostListener('document:click', ['$event'])
  onClick(event: Event) {
    if (
      this.menuSliderLeft &&
      !this.sideLeftMenu?.sideMenuWrapper?.nativeElement?.contains(event.target)
    ) {
      console.log('closing left side menu');
      this.menuSliderLeft = false;
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    // const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    // if (
    //   (scrollTop > this.lastScrollTop && scrollTop != 0) ||
    //   window.innerHeight + window.scrollY >=
    //   document.documentElement.scrollHeight
    // ) {
    //   console.log('navbarVisible', "false")
    //   this.navbarVisible = false;
    // } else {
    //   console.log('navbarVisible', "true")
    //   this.navbarVisible = true;
    // }
    // console.log('navbarVisible', "check")
    // this.lastScrollTop = scrollTop;
  }

  openProfilePopup(tab) {
    this.marketplaceProfileSection?.tab
      ? (this.marketplaceProfileSection.tab = tab)
      : '';
    if (this.marketplaceProfileSection) {
      this.marketplaceProfileSection.showProfileMenu = true;
    }
    //problem scroll from here
    // if (isPlatformBrowser(this.platformId)) {
    //   document.body.style.overflow = 'hidden';
    // }
  }

  goTo(value: string) {
    this.router.navigate([value]);
  }

  checkPage() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.modalService.dismissAll();
        // this.showPage = event.urlAfterRedirects; // or event.url if you want the original URL
      });
  }
  openMenuOptionsModal(modal) {
    this.modalService.open(modal, {
      windowClass: 'my-modal md menu-2',
    });
  }
  openShopSignoutPopup(modal) {
    this.modalService.dismissAll();
    this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'shop_signin_pop',
    });
    // this.router.navigateByUrl('/');
  }

  modalDismissAll() {
    this.modalService.dismissAll();
  }

  public logout(): void {
    this.auth
      .logout_customer_marketplace({ id: this.appUserId })
      .subscribe((response: ApiResponse) => { });
    this.modalDismissAll();
    this.toastr.success('Sign out successfully.');
    this.memberNotificationService.clearNotification();
    this.local.logout();
    //this.local.fetchUser();
    //this.router.navigateByUrl('/');
    window.location.reload();
  }

  public openSigninModal(): void {
    this.signIn.loginStage = '';
    this.signIn.openSignInPopup();
  }

  handleReport(id: any = 0, category = 'system_report') {
    this.local.alertReport().then((result) => {
      if (result.isConfirmed && result.value) {
        const report = result.value;
        this.auth
          .submitReportMessage({
            message: report.reportDetails,
            type: report.reportType,
            category: category,
            product_id: id,
          })
          .subscribe(
            (response: any) => {
              this.toastr.success('Reported successfully');
            },
            (e) => {
              this.toastr.error(e.error.message);
            }
          );
      }
    });
  }
  // @HostListener('window:beforeunload', ['$event'])
  // whenLeaveSite(event: BeforeUnloadEvent): void {
  //   event.preventDefault();
  //   event.returnValue = 'Do you wish to exit the website?'; // This triggers the default "Are you sure you want to leave?" dialog
  // }
}
